export const formatThousandDecimal = (value: number, countDecimal?: number) => {
  if (value === null || value === undefined) {
    return "-";
  }

  countDecimal = countDecimal ?? 2;

  const formatter = new Intl.NumberFormat("en-TH", {
    minimumFractionDigits: countDecimal,
    maximumFractionDigits: countDecimal
  });

  return formatter.format(value);
};

export const formatThousandInteger = (value: number) => {
  if (value === null || value === undefined) {
    return "-";
  }

  const formatter = new Intl.NumberFormat("en-TH", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  return formatter.format(value);
};

export const calculateNewTotalWeightCommon = (
  newQuantity,
  weightPerUnit = 0,
  weightUnit,
  root
) => {
  let newTotalWeight;
  if (newQuantity) {
    const rootUnit = root === "ตัน" ? "TON" : root;
    const currentUnit = weightUnit === "ตัน" ? "TON" : weightUnit;

    if (rootUnit !== currentUnit) {
      if (currentUnit === "Kg.") {
        weightPerUnit = weightPerUnit * 1000;
      } else {
        weightPerUnit = weightPerUnit / 1000;
      }
    }

    newTotalWeight = newQuantity * weightPerUnit;
    newTotalWeight = shortenLongDecimal(newTotalWeight, 4);
  } else {
    newTotalWeight = 0;
  }
  return newTotalWeight;
};

export const calculateNewTotalWeight = (newQuantity, itemData) => {
  let newTotalWeight = 0;
  if (newQuantity) {
    const baseWeightUnit = itemData.baseWeightUnit || itemData.weightUnit;
    let weightPerUnit = itemData.weightPerUnit || itemData.weight;
    const rootUnit = baseWeightUnit === "ตัน" ? "TON" : baseWeightUnit;
    const currentUnit =
      itemData.weightUnit === "ตัน" ? "TON" : itemData.weightUnit;

    if (rootUnit !== currentUnit) {
      if (currentUnit === "Kg.") {
        weightPerUnit = weightPerUnit * 1000;
      } else {
        weightPerUnit = weightPerUnit / 1000;
      }
    }

    newTotalWeight = newQuantity * weightPerUnit;
    newTotalWeight = shortenLongDecimal(newTotalWeight, 4);
  } else {
    newTotalWeight = 0;
  }
  return newTotalWeight;
};

export const shortenLongDecimal = (number: number, maxDecimal: number = 2) => {
  const numberArr = number.toString().split(".");
  let resultNumber = number;
  if (numberArr.length > 1) {
    const floatNumber = numberArr[1];
    if (floatNumber.length > maxDecimal) {
      resultNumber = Number(number.toFixed(maxDecimal));
    }
  }
  return resultNumber;
};

export const calculateNewPackage = (value, reamRollPerPallet) => {
  const rawValue = value / reamRollPerPallet;
  const stringValue = rawValue.toString();
  const arrValue = stringValue.split(".");
  let interValue = arrValue[0] ? parseInt(arrValue[0], 10) : 0;
  const floatValue = arrValue[1] ? arrValue[1].toString() : "0";
  if (parseInt(floatValue[0], 10) >= 7) {
    interValue++;
  }
  return interValue;
  // return interValue ? interValue : 1;
};

export const calculateNewPalletNo = (arr, index) => {
  if (index < 1) {
    const packageQuantity =
      calculateNewPackage(arr[index]?.quantity, arr[index]?.rollPerPallet) || 1;
    return `1-${packageQuantity}`;
  } else {
    const previousPalletNo = calculateNewPalletNo(arr, index - 1);
    const arrPalletNo = previousPalletNo.split("-");
    const lastPalletNo = parseInt(arrPalletNo[1], 10);
    const packageQuantity =
      calculateNewPackage(arr[index]?.quantity, arr[index]?.rollPerPallet) || 1;
    return `${lastPalletNo + 1}-${lastPalletNo + packageQuantity}`;
  }
};

export const convertRateQuantity = (quantity, calculation) => {
  if (!calculation) {
    calculation = 0;
  }
  const rateConvert = parseFloat(calculation) / 1000;
  return rateConvert ? quantity * rateConvert : quantity;
};

export const calculateTheWeight = (
  weightUnit: string,
  saleQtyFactor: number,
  orderQty: number
): number => {
  if (!weightUnit) {
    return 0;
  }
  if (weightUnit === "Kg.") {
    return saleQtyFactor * orderQty;
  }
  return (saleQtyFactor / 1000) * orderQty;
};

export const calculateThePrice = (
  weightUnit: string,
  weight: number,
  conditionRate: number
): number => {
  if (!weightUnit) {
    return 0;
  }
  if (weightUnit === "TON") {
    return weight * conditionRate;
  }
  if (weightUnit === "Kg.") {
    return (weight / 1000) * conditionRate;
  }
};

export const roundDecimal = (num: number, decimals = 2) => {
  if (Math.abs(num) < 1e-10) {
    return 0;
  }
  const factor = 10 ** decimals;
  return Math.round((num + Number.EPSILON) * factor) / factor;
};
